import {
  Artist,
  ArtistService,
  AdminService,
  IdAndSlug,
  SmallArtist,
  UserActionsService,
  SectionType,
  AdminUserCallsService,
} from '@beatgig/api-services'
import { parseArtistSlug } from '@beatgig/navigation/routes/artist-routes'
import { mutate, cache } from 'swr'
import { DiscoverPage } from './discover-page'

type Props = {
  slug: string
  id?: string
}
export class ArtistApi {
  id: string
  slug?: string
  constructor(id: string, slug?: string) {
    this.id = id
    this.slug = slug
  }
  static getAllIds() {
    return AdminService.getArtistIds({})
  }
  static getSlugAndIds = AdminService.getArtistIds
  static getAll = AdminService.getArtists
  static getAllSlugsAndIds = async () => {
    let lastDocId = ''
    const ids_and_slugs: IdAndSlug[] = []

    while (true) {
      const data = await ArtistApi.getSlugAndIds({
        lastDocId,
        limit: 500,
      })
      if (!data.length) break
      ids_and_slugs.push(...data)
      lastDocId = data[data.length - 1].artist_id
    }

    return ids_and_slugs
  }
  static async getStaticallyGeneratedArtists() {
    const idsAndSlugs: IdAndSlug[] = []
    const discoverPage = await DiscoverPage.get()

    discoverPage.forEach((section) => {
      if (section.sectionType === SectionType.ARTIST_ROW) {
        section.data.artists.forEach(({ id: artist_id, slug }) => {
          idsAndSlugs.push({ artist_id, slug })
        })
      }
    })
    return idsAndSlugs
  }
  // get() {
  //   return ArtistService.getArtist({
  //     artistId: this.id,
  //   })
  // }
  static getById(artistId: string) {
    return ArtistService.getArtist({
      artistId,
    })
  }
  get swrKey(): [string, string | undefined, 'artist'] {
    return [this.id, this.slug, 'artist']
  }
  static getAllSwrKey({
    limit,
    lastDocId,
  }: {
    limit?: number
    lastDocId?: string
  }): ['all-artists', number | undefined, string | undefined] {
    return ['all-artists', limit, lastDocId]
  }
  refetchSWR() {
    return mutate(this.swrKey)
  }
  // mutateSWRCacheFromServer(artist: Artist) {
  //   return mutate(this.swrKey, artist, false)
  // }
  static mutateSWRCacheFromServer(artist: Artist) {
    if (!artist) return
    const key = ArtistApi.getSWRKey({ id: artist.id, slug: artist.slug })

    console.log('[artist-api] will mutate artist cache', { key })

    return mutate(key, artist, false)
  }
  // getFromCache(): Artist | null {
  //   return cache.get(this.swrKey)
  // }
  static getFromCache(props: Props): Artist | null {
    return cache.get(ArtistApi.getSWRKey(props))
  }
  static getSWRKey({ slug }: Props): [string, 'artist'] {
    return [parseArtistSlug(slug), 'artist']
  }
  static editFullObject(artist: Artist, user: string) {
    return ArtistService.editFullArtist({
      // artistId: artist.id,
      requestBody: artist,
      // user,
    })
  }
  static create = (artist: Artist, user: string) => {
    try {
      return ArtistService.createArtist({
        requestBody: artist,
        // user
      })
    } catch (e) {
      console.error(e.message)
    }
  }
  static getBySlug = ({ slug }: { slug: string }) => {
    return ArtistService.getArtistBySlug({ slug: parseArtistSlug(slug) })
  }
  static getSimilarArtists = (artistId: string) => {
    return ArtistService.getSimilarArtists({
      artistId,
    })
  }
  static similarArtistsSWRKey(id?: string) {
    if (!id) return null
    return [id, 'similar-artists']
  }
  static isSmallArtist(artist: Artist | SmallArtist): artist is SmallArtist {
    return !!(artist && (artist as SmallArtist).is_small_artist)
  }
  static async publish({ id, unpublish }: { id: string; unpublish: boolean }) {
    return AdminUserCallsService.publishArtist({
      artistId: id,
      unpublish,
    })
  }
}

// keep these to see the TS types
// editSingleArtistField<K extends Object.Paths<Artist>>(
//   key: K,
//   newValue: Object.P.Pick<Artist, K>,
//   isImage = false,
//   isImageArray = false
// ) {
//   // return ArtistService.editArtistFieldArtistEditArtistFieldPost({
//   //   artistId: this.id,
//   //   requestBody: {
//   //     path_to_key: key as string[],
//   //     new_value: newValue,
//   //     is_image: isImage,
//   //     is_image_array: isImageArray,
//   //   },
//   // })
// }
// editName(name: string) {
//   return this.editSingleArtistField(['name'], {
//     name,
//   })
// }
// editProfileImage(url: string) {
//   return this.editSingleArtistField(
//     ['profile_image'],
//     {
//       profile_image: {
//         url,
//         height: 0,
//         width: 0,
//       },
//     },
//     true
//   )
// }
// editCoverImage(url: string) {
//   return this.editSingleArtistField(
//     ['cover_image'],
//     {
//       cover_image: {
//         url,
//         height: 0,
//         width: 0,
//       },
//     },
//     true
//   )
// }
// editGenre() {}
// editPrice({ rate_high, rate_low }: { rate_low: number; rate_high: number }) {
//   this.editSingleArtistField(['price', 'rate_low'], {
//     price: {
//       rate_low,
//     },
//   })
// }
